import React, { Component,useEffect,useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../../config.js'
import DataTable,{defaultThemes} from 'react-data-table-component';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";


// import DataTable from 'datatables.net-react';
// import DT from 'datatables.net-dt';

// DataTable.use(DT);
import {
	statisticsAction,
	statisticsCloseAction
} from '../../../actions/settingsAction.js';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';





const EmployeeControl = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;


	const [user, setUser] = useState({
        first_name: "",
        last_name: "",
        gender: "",
		date_of_joining: "",
		designation:"",
		floor:"",
		role:"",
		email:"",
		date_of_birth:"",
		password:"",
		confirm_password:"",
		contact_no:"",
		employee_type:"",
		address:"",
		// employee_shift:"",
		// contractor:"",
		// contractor_type:"",

    })

   
	//   const [gender, setGender] = useState("");
	  const [selectedDate, setSelectedDate] = useState(null);

    const handelInput = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        console.log(name, value)
        setUser({ ...user, [name]: value });
    }


	const handelEmployeeShift=(event)=> {
		setEmployeeshift(event.target.value);
	}

	

	
	const history = useHistory();
	const [data, setData]= useState([]);
    const [dataval, setdataval]= useState([]);
	const [floorval, setfloorval]= useState([]);
	const [roleval, setroleval]= useState([]);
	const [settingval,setsettingval]=useState("");
	const [currentPageId, setCurrentPageId]= useState(1);

	
	// const [anand, setAnand]= useState([]);
	const [searchTerm, setSearchTerm] = useState("");
	const [currentPage, setCurrentPage] = useState(1);
	const [itemsPerPage, setItemsPerPage] = useState(100);
	// const itemsPerPage = 10;
	const indexOfLastItem = currentPage * itemsPerPage;
	const indexOfFirstItem = indexOfLastItem - itemsPerPage;
	let filteredItems = data.filter((item) =>
	
		

	  `${item.employee_id.toLowerCase()}${item.first_name.toLowerCase()}${item.last_name.toLowerCase()}${item.department_name.toLowerCase()}${item.designation_name.toLowerCase()}${item.employee_shift.toLowerCase()}${item.is_active.toLowerCase()}`.includes(searchTerm.toLowerCase())
	 
	);
	const filteredData = filteredItems.slice(indexOfFirstItem, indexOfLastItem);
	const startIndex = (currentPage - 1) * itemsPerPage;
  
	useEffect(() => {
	  setCurrentPage(1);
	}, [searchTerm]);
  
	const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };


  const handleRowsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to first page
  };
  
	

	useEffect(()=> {
		axios.get(API_BASE_URL +'/showallinactiveemployee', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})

	
		 .then(res => setData(res.data.user_det))
		//.then(res => console.log(res.data.user_det))
		.catch(err => console.log(err));
	},[])


	useEffect(()=> {
		axios.get(API_BASE_URL +'/showsetting', { headers : {
			'Content-Type': 'application/json'
	}})

	
		.then(res => setsettingval(res.data.default_password))
		// .then(res => console.log(res.data.default_password))
		.catch(err => console.log(err));
	},[])


	

	// useEffect(() => {
	// 	handleUpdate();
	//   }, []);




	  const recordsPerPage=50;

	  const lastIndex=currentPage * recordsPerPage;
	  const firstIndex= lastIndex - recordsPerPage;
	  const records = data.slice(firstIndex, lastIndex);
	  const npage = Math.ceil(data.length/ recordsPerPage);
	  const numbers = [...Array(npage+1).keys()].slice(1);

	
	  const handleDepartment = async () => {

		axios.get(API_BASE_URL +'/showdepartment/', { headers : {
			   'Content-Type': 'application/json',
			   //'Authorization': 'Bearer 154|DKlDECT0m8FjNaqkz80nCzrt5ziZ8kW2XsaIzEkj260b0b39'
	   }})
		.then(res1 => setdataval(res1.data))
		.catch(err => console.log(err))
	   };


	   useEffect(() => {
		handleDepartment();
	  }, []);



	 
	




	  const handleFloor = async () => {

		axios.get(API_BASE_URL +'/showfloor/', { headers : {
			   'Content-Type': 'application/json',
			   //'Authorization': 'Bearer 154|DKlDECT0m8FjNaqkz80nCzrt5ziZ8kW2XsaIzEkj260b0b39'
	   }})
		.then(res1 => setfloorval(res1.data))
		.catch(err => console.log(err))
	   };


	   useEffect(() => {
		handleFloor();
	  }, []);


	  const handleRole = async () => {

		axios.get(API_BASE_URL +'/showrole/', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
		.then(res1 => setroleval(res1.data))
		.catch(err => console.log(err))
	   };


	   useEffect(() => {
		handleRole();
	  }, []);


// 	const handleSubmit =async (e) => {

// 		e.preventDefault();
// 		axios.post(API_BASE_URL+'/addemployee', { first_name: user.first_name, last_name: user.last_name,gender: user.gender,date_of_joining: user.date_of_joining, department: department,designation: designation,floor: user.floor,role: user.role,email: user.email,date_of_birth: user.date_of_birth,password: user.password, confirm_password: user.password, contact_no: user.contact_no,employee_type: user.employee_type,employee_shift: user.employee_shift,address: user.address }, {
// 			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
// 		}).then(response => {
// 			console.log(response.data);
// 			console.log(response.data.message);
// 		})
			
	
// };


const handleSubmit = async (e) => {

	e.preventDefault();
   

	// setError(null);
	// setLoading(true);
	// e.preventDefault();
	axios.post(API_BASE_URL+'/addemployee', { first_name: user.first_name, last_name: user.last_name,gender: user.gender,date_of_joining: user.date_of_joining, department_id: department,designation_id: designation,floor_id: user.floor,role: user.role,email: user.email,date_of_birth: user.date_of_birth,password: settingval, confirm_password: settingval, contact_no: contact_no,emp_type: user.employee_type,employee_shift: employee_shift,address: user.address,contractor_id:contractor,employeetype_id:contractortype}, {
					headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
				}).then(response => {
		// 	console.log(response.data);
		// 	console.log(response.data.message);
		// })

		var status = response.data.status;

		if (status == 200) {
			toast.success(response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",

			});


			const timeout = setTimeout(() => {
				window.location.reload(); // Reload the current page
			}, 5000); // Refresh after 5 seconds

			return () => {
				clearTimeout(timeout); // Cleanup the timeout if the component unmounts
			};

		} else if(status == 401) {
			toast.error(response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",

			});
		}
		else if (status == 400) {
			toast.error(response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",

			});
		}


	}).catch(error => {
		// console.log(error);
		// console.log(error.response.data.message);




		toast.error(error.response.data.message, {
			position: "bottom-right",
			autoClose: 5000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
			theme: "colored",


		});

	});
};


 const [toggle,setToggle]=useState(false);
 const clearInput = () => {
	setSearchTerm("");
  };


 const [department, setDepartmentValue] = useState("");
 const [designationDropdownOptions,setDesignationDropdownOptions]=useState([]);
 const [designation,setDesignationValue] = useState("");
 const [contact_no, setNumValue] = useState("");
 //const [firstDropdownValue, setFirstDropdownValue] = useState("");
//   const [secondDropdownOptions, setSecondDropdownOptions] = useState([]);
//   const [secondDropdownValue, setSecondDropdownValue] = useState("");

  // Handle first dropdown change
  const handleFirstDropdownChange = (event) => {
    const value = event.target.value;
    setDepartmentValue(value);

    // Trigger API call based on the selected value
    fetchSecondDropdownOptions(value);
  };



   // Fetch options for the second dropdown
   const fetchSecondDropdownOptions = async (selectedValue) => {
    try {
    
	const response = await fetch(
        API_BASE_URL + '/showdesignation/'+selectedValue
      ); // Replace with your API URL

      const data = await response.json();
      setDesignationDropdownOptions(data); // Assuming the API returns an array of options
    } catch (error) {
      console.error("Error fetching second dropdown options:", error);
    }
  };

    // Handle second dropdown change
	const handleSecondDropdownChange = (event) => {
		// setSecondDropdownValue(event.target.value);
		setDesignationValue(event.target.value);
	  };


	  const handelNumber = (e) => {
		const inputValue = e.target.value;
	
		// Allow only numeric characters
		if (/^\d*$/.test(inputValue)) {
			setNumValue(inputValue);
		}
	  };



	  const [employee_shift,setEmployeeshift]= useState("");
	  const [contractordata,setContractorData]= useState([]);
	  const [contractor,setContractorValue]= useState("");
	  const [contractotypeDropdownOptions,setContractorTypeDropdownOptions]= useState([]);
	  const [contractortype,setContractorTypeValue]= useState("");
	  const [shiftemployee,setShiftEmployee]=useState("");


	  const handleContractor = async () => {

		axios.get(API_BASE_URL +'/showcontractor/', { headers : {
			   'Content-Type': 'application/json',
			   //'Authorization': 'Bearer 154|DKlDECT0m8FjNaqkz80nCzrt5ziZ8kW2XsaIzEkj260b0b39'
	   }})
		.then(res1 => setContractorData(res1.data))
		.catch(err => console.log(err))
	   };


	   useEffect(() => {
		handleContractor();
	  }, []);



	  const handleContractorDropdownChange = (event) => {
		const value = event.target.value;
		setContractorValue(value);
	
		// Trigger API call based on the selected value
		fetchContractorTypeDropdownOptions(value);
	  };
	
	
	
	//    Fetch options for the second dropdown
	   const fetchContractorTypeDropdownOptions = async (selectedValue) => {
		try {
		
		const response = await fetch(
			API_BASE_URL + '/showcontractortype/'+selectedValue
		  ); // Replace with your API URL
	
		  const data = await response.json();
		  setContractorTypeDropdownOptions(data); // Assuming the API returns an array of options
		} catch (error) {
		  console.error("Error fetching second dropdown options:", error);
		}
	  };
	
		// Handle second dropdown change
		const handleContractorTypeDropdownChange = (event) => {
			// setSecondDropdownValue(event.target.value);
			setContractorTypeValue(event.target.value);
		  };


		  const handelShiftEmployee = (event) => {

			setEmployeeshift(event.target.value);
	
			// if (event.target.value === '1') {
			// 	setIsVisible(true);
			// } else {
			// 	setIsVisible(false);
			// }
		}


		const [isYes, setIsYes] = useState(true);


		
		

	return (
		<>

		
			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

						<ToastContainer/>
							{/* <div className="d-flex justify-content-between align-items-center mb-3">
								<div className="header-action">
								<div id="button">
									<button style={{float: 'center'}}
										type="button"
										className="btn btn-primary"
										data-toggle="modal"
										data-target="#exampleModal"
									>
										<i className="fe fe-plus mr-2" />
										Add 
									</button>
								</div>
								</div>
							</div> */}

						</div>
					</div>


					


					<div className="section-body">
						<div className="container-fluid">
							<div className="tab-content">
								<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
									<div className="card">

								
                                    
										<div className="card-header">

										<div className="card-header">
                                              <h3 className="card-title" style={{color:'#e96827',alignItems: 'right'}}>InActive Employee List</h3>
                                             </div>
											
											<div className="card-options" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px' }}>
												
											


													<div className="input-group">

													<select style={{
																padding: '8px',
																marginRight: '20px',
																borderRadius: '4px',
																border: '1px solid #ccc',
																backgroundColor: '#BCD1DB',display: 'flex', justifyContent: 'left'
															  }}
														id="rowsPerPage"
														value={itemsPerPage}
														onChange={handleRowsPerPageChange}
													>
														
														<option value={50}>50</option>
														<option value={100}>100</option>
														<option value={250}>250</option>
													</select>
													
													<div style={{ position: "relative", width: "300px" }}>

													<input
															type="text"
															className="form-control form-control-sm"
															placeholder="Search"
															value={searchTerm}
															onChange={handleSearch} 
															style={{
																width: "100%",
																padding: "10px",
																paddingRight: "30px", // Extra space for the clear icon
																boxSizing: "border-box",
															  }} 
														/>


{searchTerm.length>0 && ( 
        <span
          onClick={clearInput}
          style={{
            position: "absolute",
			top: "50%",
			right:"10px",
			transform: "translateY(-50%)",
            cursor: "pointer",
            color: "#aaa",
            fontSize: "18px",
			// marginLeft: '260px !important',
            
          }}
        >
          ✖
        </span>
       )}
													</div>
														


														
													</div>
												
											</div>
										</div>


										
										


										

										



										<div className="card-body">
											<div className="table-responsive">
												<table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
													<thead>
														<tr>
                                                            <th>Action</th>
															<th>ID</th>
															<th>Name</th>
															<th>Department</th>
															<th>Designation</th>
															<th>Employee Type</th> 
                                                            <th>Status</th>
															
														</tr>
													</thead>
													<tbody>



                                                    

													

                                                        {
                                                            filteredData.map((emp,index) => {

                                                        return <tr key={index}>
                                                            <td className="d-flex">
                                                            <Link to={`/employees-detail?id=${emp.user_id}`}>
                                                                <i className="fe fe-maximize" />
                                                            </Link>
                                                                
                                                            </td>
                                                            <td>
																<span>{emp.employee_id}</span>
															</td>
															<td>
																<span>{emp.first_name} {emp.last_name}</span>
															</td>
															<td>
																<span>{emp.department_name}</span>
															</td>
                                                            <td>
																<span>{emp.designation_name}</span>
															</td>
                                                            <td>
                                                            <span className="tag" style={{backgroundColor:"#2760fb",color:"white"}}>{emp.employee_shift}</span>
															</td>
                                                            <td>
																<span>{emp.is_active}</span>
															</td>
                                                        </tr>


                                                        })
                                                        }

														
													</tbody>
												</table>
											</div>

											

									 <nav aria-label="Page navigation">
										<ul className="pagination mb-0 justify-content-end">
										<li className="page-item"><button className="page-link"
                key={'f'}
                onClick={() => paginate(1)}
              >
                First
              </button></li>
										
          {Array.from(
            { length: Math.ceil(filteredItems.length / itemsPerPage) },
            (_, index) => (
				<li className="page-item">
              <button className="page-link"
                key={index + 1}
                onClick={() => paginate(index + 1)}
              >
                {index + 1}
              </button></li>
            )
          )}

<li className="page-item">
			<button className="page-link"
                key={'l'}
                onClick={() => paginate(Math.ceil(filteredItems.length / itemsPerPage))}
              >
                Last
              </button></li>

										</ul>
									</nav> 






									


										</div> 
									</div>
								</div>
	
							
							</div>
						</div>
					</div>

				</div>
			</div>

							

			

			


			

		</>
	);

}



const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(EmployeeControl);